import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';

type TasksMetricsProps = {
  data?: {
    date: number;
    total: number;
    manual: number;
    function: number;
    server: number;
    spot: number;
  }[];
};

const TasksMetrics = ({ data }: TasksMetricsProps) => {
  const isData = data && data.length > 0;

  // แปลงข้อมูลสำหรับ series
  const series: ApexAxisChartSeries = [
    {
      name: 'Manual',
      data: data?.map(item => item.manual) || [],
      color: 'hsl(var(--chart-1))'
    },
    {
      name: 'Function',
      data: data?.map(item => item.function) || [],
      color: 'hsl(var(--chart-2))'
    },
    {
      name: 'Server',
      data: data?.map(item => item.server) || [],
      color: 'hsl(var(--chart-6))'
    },
    {
      name: 'Spot',
      data: data?.map(item => item.spot) || [],
      color: 'hsl(var(--chart-3))'
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 300,
      stacked: true,
      toolbar: {
        show: true,
        tools:{
          download: false
        }
      },
      zoom: {
        enabled: true,
      },
    },
    legend: {
      markers: {
        shape: 'circle',
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 2,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
        dataLabels: {
          hideOverflowingLabels: true,
          total: {
            enabled: true,
            formatter: function (total) {
              if (!total) return '';
              return total
            }
          }
        },
      },
    },
    xaxis: {
      type: 'datetime',
      categories: data?.map(item => item.date) || [],
      labels:{
        datetimeUTC: false,
      }
    },
    fill: {
      opacity: 1,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  return (
    <div>
      {isData ? (
        <Chart options={options} series={series} type="bar" height={300} />
      ) : (
        <div className='text-center text-sm text-muted-foreground'>No data</div>
      )}
    </div>
  );
};

export default TasksMetrics;
